import React from "react";
import SelfPicture from "../assets/images/self-picture2.jpg";
import "../assets/css/Homepage.css";

function HomePage() {
    return (
        <div className="body">
            <main className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                            <h1 className="headingStyle">About Me</h1>
                        <hr />
                        <div className="row">
                            <section className="col-md-6">
                                <img src={SelfPicture} height="85%" width="70%" alt="" className="selfPicture"/>
                            </section>
                            <aside className="col-md-6">
                                <p className="content">My name is Kevin Hellman. I was born in Durham, North Carolina, but moved shortly after to Apex. I went to Apex elementary, middle, and high school.</p>
                                <p className="content">I graduated from N.C. State University with a bachelor's degree in Psychology. During the Covid-19 Pandemic I saw an opportunity to go back to school and learn programming.</p>
                                <p className="content">I recently completed a Full-Stack Coding Bootcamp associated with UNC Chapel Hill</p>
                                <p className="content">After that bootcamp I have continued to learn new, important technologies such as Python on my own</p>
              
                            </aside>
                        </div>
                    </div>
                </div>
                <br />
            </main>
        </div>
    )
}

export default HomePage;